import React, { useContext, useEffect, useState,Form  } from 'react'
import PageTitle from '../../../jsx/layouts/PageTitle';
import ReactPaginate from 'react-paginate';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { getOrganisationList, getOrganisationListForExcel } from '../../../services/adminApiService/organisationApi/OrganisationApiService';
import { useNavigate } from 'react-router-dom';
import { getIndividaulList } from '../../../services/adminApiService/individualApiService/IndividualAPiService';
import { formatDateTime } from '../../../utils/dateTimeFormate';
import { formatStatus, getStatusColor } from '../../../utils/colorAsperStatus';
import {
    deleteVerifiedUserData, disableVerifiedUserData,
    getAlldataverifiedDwnload,
    getVerifieddataList
} from '../../../services/adminApiService/verifiedlistApiService/VerifiedLIstApiService';
import FilterNumber from '../../../jsx/components/FilterNumberDropDown/FilterNumber';
import SearchFilter from '../../../jsx/components/SearchFilter/SearchFilter';
import useSearchValue from '../../../hooks/useSearchValue';
import CategorySubCategoryFilter from '../categorySubCateogoryFilter/CategorySubCategoryFilter';
import DistrictFilter from '../districtFilter/DistrictFilter';
import { LocationContext } from '../../../context/LocationContext';
import { useCategoryFilter } from '../../../context/CategoryFilterContext';
import { useFilterReset } from '../../../hooks/useFilterReset';
import RefreshButton from '../../../jsx/components/RefreshButton/RefreshButton';
import { useSport } from '../../../context/SportContext';
import SportFilter from '../sportFilter/SportFilter';
import DownloadExcelButton from '../../../jsx/components/DownloadExcelButton.jsx/DownloadExcelButton';
import { IndividualExcelHeaders } from '../Individual/IndividualExcelHeader';
import { VerifiedIndividualExcelHeaders } from './VerifiedIndividualExcelData';
import InsitutionCategoryFilter from '../insitutionCategoryFilter/InsitutionCategoryFilter';
import { useGender } from '../../../context/GenderContext';
import GenderFilter from '../genderFilter/GenderFilter';
import {deleteNonVerifiedUserData} from "../../../services/adminApiService/adminCategoryType/AdminCategoryTypeApi";
import swal from "sweetalert";
import notify from "../../../utils/notification";
import {AuthContext} from "../../../context/AuthContext";
import { exportToExcel , exportVerifiedToExcel } from '../../../utils/exportToExcel';


const VerifiedUserList = ({ roletype, roleCategory }) => {
    const [verifiedUserdataList, setVerifiedUserdataList] = useState([]);
    const { selectedDistrictId, setSelectedDistrictId } = useContext(LocationContext);
    const { selectedSubCategoryId, setSelectedSubCategoryId, selectedInsitutionCategoryId, setSelectedInsitutionCategoryId } = useCategoryFilter();
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const { searchValue, setSearchValue, debouncedSearchValue, setDebouncedSearchValue } = useSearchValue();
    const [selectedCategory, setSelectedCategory] = useState('');
    const [selectedSubCategory, setSelectedSubCategory] = useState('');
    const [selectedInsitutionCategory, setSelectedInsitutionCategory] = useState('');
    const { selectedSportId, setSelectedSportId } = useSport();
    const [orgselectedCategory, setOrgSelectedCategory] = useState('');
    const { selectedGender, setSelectedGender } = useGender();
    const { user, USER_LEVEL } = useContext(AuthContext);
    const handleVerificationClick = (id) => {
        navigate(`/verification-view-form/${id}`); // Absolute path
    };

    const handleVerificationInsituteClick = (id) => {
        navigate(`/verification-insitute-view-form/${id}`); // Absolute path
    };

    const handleDataToExcel = async ({userId}) => {
          try {
              const response = await getOrganisationListForExcel(userId, searchValue,selectedDistrictId,selectedSubCategoryId,selectedSportId);
              const data = response.data;
              exportVerifiedToExcel(data,"InsitutionListVerified.csv");
          } catch (error) {
              console.error('Login error:', error);
          } 
      };

    const getverifiedListApi = async (roletype, perPage, currentPage, searchValue, selectedDistrictId,selectedCategory, selectedSubCategoryId, selectedSportId, selectedInsitutionCategoryId, orgselectedCategory, selectedGender) => {
        setLoading(true);
        try {
            const response = await getVerifieddataList(roletype, perPage, currentPage, searchValue, selectedDistrictId, selectedCategory,selectedSubCategoryId, selectedSportId, selectedInsitutionCategoryId, orgselectedCategory, selectedGender);
            setVerifiedUserdataList(response?.data?.data);
        } catch (error) {
            console.error('Login error:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getverifiedListApi(roletype, perPage, currentPage, debouncedSearchValue, selectedDistrictId,selectedCategory, selectedSubCategoryId, selectedSportId, selectedInsitutionCategoryId, orgselectedCategory, selectedGender);
    }, [currentPage, perPage, debouncedSearchValue, selectedDistrictId, selectedCategory,selectedSubCategoryId, selectedSportId, selectedInsitutionCategoryId, orgselectedCategory, selectedGender]);

    const handlePageChange = (event) => {
        const selectedPage = event.selected + 1;
        setCurrentPage(selectedPage);
    };

const calculateAge = (dob) => {
    if (!dob) return 'N/A';
    
    const birthDate = new Date(dob);
    const today = new Date();
    
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();
    
    // Adjust age if birthday hasn't occurred yet this year
    if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    
    return age;
};

    const handleDeleteClick = async (id) => {
        const isConfirm = await swal({
            title: "Are you sure you want to delete this user profile?",
            text: "This action cannot be undone, and all associated data will be permanently removed.",
            icon: "warning",
            buttons: ["Cancel", "Yes, Delete"],
            dangerMode: true,
        });

        if (!isConfirm) return; // ❌ Stop if user cancels

        try {
            const payload = { id };

            const response = await deleteVerifiedUserData(payload);

            if (response?.data?.status === true) {
                swal("Deleted Successfully", response?.data?.message, "success");
                getverifiedListApi(roletype, perPage, currentPage, debouncedSearchValue, selectedDistrictId,selectedCategory, selectedSubCategoryId, selectedSportId, selectedInsitutionCategoryId, orgselectedCategory, selectedGender);
            } else {
                notify("error", response?.data?.message);
            }
        } catch (error) {
            console.log("error", error);
            notify("error", "Something went wrong. Please try again.");
        }
    };

    const handleRefresh = useFilterReset({
        setSearchValue,
        setDebouncedSearchValue,
        setSelectedDistrictId,
        setSelectedSubCategoryId,
        selectedInsitutionCategoryId,
        // setSelectedInsitutionCategoryId,
        selectedInsitutionCategory,
        setSelectedInsitutionCategory,
        setSelectedCategory,
        setOrgSelectedCategory,
        setSelectedSubCategory,
        setPerPage,
        setCurrentPage,
        setSelectedSportId,
        fetchFunction: getverifiedListApi,
        setSelectedGender,

    });
    useEffect(() => {
        setCurrentPage(1);
        setPerPage(10);
        // setSelectedStatus(0);
        setDebouncedSearchValue("");
        setSelectedDistrictId("");
        setSelectedSubCategoryId("");
        setSelectedSportId("");
        setSelectedGender(0)

    }, []);
    return (
        <>
            <PageTitle activeMenu="Individual Verification List"
                motherMenu="Manage Verification" />
            <div className="col-12">
                <div className="card">
                    <div className=" d-flex justify-content-between px-3">
                        <div className="d-flex mt-3">
                            <div>
                                <FilterNumber value={perPage} onChange={setPerPage} />
                            </div>
                            <div>
                                <SearchFilter searchValue={searchValue} setSearchValue={setSearchValue} />
                            </div>

                        </div>
                        <div className="d-flex mt-3">
                            <div className="mx-2">
                                <DownloadExcelButton
                                    // data={verifiedUserdataList}
                                    data={
                                        (verifiedUserdataList?.data || verifiedUserdataList || []).map((item, index) => ({
                                            serial: index + 1, // ✅ add serial number
                                            ...item,
                                        }))
                                    }
                                    // headers={VerifiedIndividualExcelHeaders}
                                    headers={[
                                        { label: "Sr.No", key: "serial" }, // ✅ add serial header
                                        ...VerifiedIndividualExcelHeaders,
                                    ]}
                                    btnName="Download Excel"
                                    fileName="IndividualListVerified.xlsx" />
                            </div>
                            <div className="">
                                {/* <DownloadExcelButton data={verifiedUserdataList}
                                    // headers={VerifiedIndividualExcelHeaders}
                                    headers={[
                                        { label: "S.No", key: "serial" }, // Add Serial Number column
                                        ...VerifiedIndividualExcelHeaders
                                    ]}
                                    btnName="Download All Data"
                                    fileName="AllIndividualListVerified.xlsx"
                                    onClick={async () => {
                                        const response = await getAlldataverifiedDwnload(1);
                                        const allData = response?.data?.data || [];
                                        const withSerial = allData.map((item, index) => ({
                                            serial: index + 1,  // matches header key
                                            ...item
                                        }));

                                        return withSerial;
                                    }}

                                /> */}
                                <DownloadExcelButton btnName="Download All Data"
                                    fileName="AllIndividualListVerified.xlsx"
                                    userId={1} searchValue={searchValue} selectedDistrictId={selectedDistrictId} 
                                selectedSubCategoryId={selectedSubCategoryId} selectedSportId={selectedSportId} />
                           
                            </div>

                            <div>
                                <RefreshButton refreshCallback={handleRefresh} />
                            </div>

                        </div>
                    </div>

                    <div className=" d-flex  px-3">
                        <div className="d-flex mt-3">

                            <div>
                                <DistrictFilter />

                            </div>
                        </div>
                        <div className="d-flex mt-3">

                            <div className="mx-2">
                                <CategorySubCategoryFilter typeId="1"
                                    selectedCategory={selectedCategory}
                                    setSelectedCategory={setSelectedCategory}
                                    selectedSubCategory={selectedSubCategory}
                                    setSelectedSubCategory={setSelectedSubCategory}
                                    placeholderText="Individual"
                                                           setCurrentPage={setCurrentPage}
                                />
                            </div>
                            <div>
                                <SportFilter />
                            </div>

                        </div>
                    </div>
                    <div className="mx-4 d-flex">
                        <div>
                            <InsitutionCategoryFilter typeId="2"
                                orgselectedCategory={orgselectedCategory}
                                setOrgSelectedCategory={setOrgSelectedCategory}
                                selectedInsitutionCategory={selectedInsitutionCategory}
                                setSelectedInsitutionCategory={setSelectedInsitutionCategory}
                                setCurrentPage={setCurrentPage}
                            />
                        </div>

                        <div>
                            <GenderFilter setCurrentPage={setCurrentPage} />
                        </div>
                    </div>

                    <div className="card-body">
                        <div className="w-100 table-responsive">
                            <div id="example_wrapper" className="dataTables_wrapper">
                                <table id="example" className="display w-100 dataTable">
                                    <thead>
                                        <tr>
                                            <th>SN</th>
                                            {/* <th>Prov.Reg.Id</th> */}
                                            <th>Atom Id</th>
                                            <th>Applicant Full Name</th>
                                            <th>Email Id</th>
                                            <th className="text-center">Age</th>
                                            <th>Organization Type</th>
                                            <th>Organization Name</th>
                                            {/* <th>Contact Number</th> */}
                                            <th>Registration Date</th>
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr>
                                                <td colSpan="9" className="text-center">
                                                    <div className="spinner-border text-primary" role="status">
                                                        <span className="sr-only">Loading...</span>
                                                    </div>
                                                </td>
                                            </tr>
                                        ) : verifiedUserdataList?.data?.length > 0 ? (
                                            verifiedUserdataList.data.map((data, index) => {
                                                const serialNumber = (currentPage - 1) * perPage + (index + 1);
                                                return (
                                                    <tr key={index}>
                                                        <td>{serialNumber}</td>
                                                        {/* <td>{data?.registration_id}</td> */}
                                                        <td>{data?.atom_id}</td>
                                                        <td>{data?.name}</td>
                                                        <td>{data?.email}</td>
                                                        <td>{calculateAge(data?.indivisual?.dob)}</td>                                                       
                                                        <td>{data?.orgnization_type}</td>
                                                        <td>{data?.orgnization_name}</td>
                                                        {/* <td>{data?.indivisual?.mobile}  </td> */}
                                                        <td>{formatDateTime(data?.created_at)}</td>
                                                        <td>
                                                            <span className="text-success">Verified</span>
                                                        </td>
                                                        <td>
                                                            <div className="d-flex">
                                                                {user?.role === "admin" &&
                                                                    user?.user_level == USER_LEVEL.ADMIN && (
                                                                        <div>
                                                                            <Button
                                                                                variant="danger"
                                                                                style={{ whiteSpace: 'nowrap' }}
                                                                                onClick={() => handleDeleteClick(data?.id)}
                                                                            >
                                                                                Delete
                                                                            </Button>
                                                                        </div>
                                                                    )}



                                                                <div className="mx-2">
                                                                    <Button
                                                                        style={{ whiteSpace: "nowrap" }}
                                                                        onClick={() => handleVerificationClick(data?.id)}
                                                                    >
                                                                        View More
                                                                    </Button>
                                                                </div>


                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        ) : (
                                            <tr>
                                                <td colSpan="9" className="text-center">Data is not available</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                </div>
                <ReactPaginate
                    nextLabel="next >"
                    onPageChange={handlePageChange}
                    pageRangeDisplayed={8}
                    marginPagesDisplayed={7}
                    pageCount={Math.ceil(verifiedUserdataList?.total / perPage)}
                    previousLabel="< previous"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakLabel="..."
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="pagination d-flex flex-wrap"
                    activeClassName="active"
                    renderOnZeroPageCount={null}
                />
            </div>
        </>
    )
}

export default VerifiedUserList